const quotationBlob = ()=>{
  const prefix = 'quotation_blob',
    component = document.querySelectorAll(`.${prefix}`);

  if (exists(`.${prefix}`)) {

    for (let i = 0; i < component.length; i++) {
      const blob = component[i],
        min = blob.getAttribute('data-quotation-blob-min'),
        max = blob.getAttribute('data-quotation-blob-max'),
        random = randomNumber(min, max);

      if (min === null || max ===  null) {
        return;
      }

      blob.classList.add(`${prefix}--${random}`);
    }
  }
}

quotationBlob();
